import React from "react";
import { Typography } from "@aph/ui-lib-humanx";
import IconRight from "$/icons/icon-right.svg";
import Image from "@/components/Image";
import { NEXT_PUBLIC_CDN_URL } from "@/libs/constants/auth";
import { DeviceInfo } from "@/interface/deviceInfo";
import styles from "./initialCard.module.scss";

interface InitialCardProps {
  setInitialCard: (value: boolean) => void;
  deviceInfo: DeviceInfo;
}

const InitialCard: React.FC<InitialCardProps> = ({ setInitialCard, deviceInfo }) => {
  return (
    <>
      <div className={styles.background}>
        {deviceInfo?.isMobile ? (
          <Image src={`${NEXT_PUBLIC_CDN_URL}/images/momverse/valentine/valentine_bg_first.png`} alt="Valentine BG" />
        ) : (
          <Image
            src={`${NEXT_PUBLIC_CDN_URL}/images/momverse/valentine/valentine_bg_first_desktop.png`}
            alt="Valentine BG Desktop"
            className={styles.dekstop}
          />
        )}
      </div>
      <div className={styles.wrapper}>
        <Typography varient={"h3"} className={styles.title}>
          The Little Big Things Wishlist
        </Typography>
        <Typography className={styles.description}>
          Only a mom knows that a nap is more precious than a box of chocolates. Share{" "}
          <strong>the little big things wishlist</strong> and let your partner in on this little secret
        </Typography>
        <button type={"button"} className={styles.btn} onClick={() => setInitialCard(false)}>
          Send a card
          <span>
            <IconRight />
          </span>
        </button>
      </div>
    </>
  );
};

export default InitialCard;
